module.exports = __webpack_public_path__ + "img/Burkina Faso.d4598005.svg";